module.exports = __webpack_public_path__ + "img/qiuzhi.e7330bde.png";